export const validateNativeApiOrigin = (value) => {
    let url;
    try {
        url = new URL(value);
    } catch {
        throw new Error('Native builds require VITE_NATIVE_API_BASE_URL to be an absolute HTTPS origin.');
    }
    if (url.protocol !== 'https:' || url.username || url.password ||
        url.pathname !== '/' || url.search || url.hash) {
        throw new Error('VITE_NATIVE_API_BASE_URL must be an HTTPS origin without credentials, path, query, or fragment.');
    }
    return url.origin;
};
